'use client'
import React, { useState } from 'react'
import Image from 'next/image'
import { Button, Modal, ModalContent, ModalBody, Spinner, useDisclosure } from "@heroui/react"
import { FaTimes } from 'react-icons/fa'

const ImageModal = ({ isOpen, onOpenChange, imageUrl }) => {
  const [loaded, setLoaded] = useState(true)
  return (
    <Modal 
      isOpen={isOpen} 
      onOpenChange={onOpenChange}
      size="2xl" 
      placement="center"
      hideCloseButton
      className='mx-4 md:mx-0'
    >
      <ModalContent className="bg-transparent shadow-none">
        {(onClose) => (
          <>
            <div className="absolute top-2 right-2 z-50">
              <Button 
                isIconOnly 
                color="danger" 
                variant="solid" 
                onPress={onClose}
                aria-label="Close"
                className="bg-opacity-70"
              >
                <FaTimes />
              </Button>
            </div>
            <ModalBody className="flex items-center justify-center bg-chOffWhite-200 min-h-[vh75] max-h-[90vh] px-0 py-0">
            
                {!loaded && <Spinner size='xl' />}
                <Image 
                  src={imageUrl}
                  width={0} 
                  height={0} 
                  alt="Full size image" 
                  className="object-contain max-h-full max-w-full w-auto h-auto rounded-md"
                  sizes='90vw'
                  priority
                  unoptimized
                  onLoad={() => setLoaded(true)}
                />
              
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

const FeedImage = ({ img, openImageModal }) => {
    const [loaded, setLoaded] = useState(false)
    const [imgError, setImgError] = useState(false)
    
    return !imgError ? <div 
      onClick={() => openImageModal(img)} 
      className={`cursor-pointer transition-transform hover:scale-[1.02] active:scale-[0.98] relative w-full aspect-[4/3] `}
    >  
      <Image 
        src={`${process.env.CDN}/${img}`}
        width={0} height={0} 
        alt='Feed Post Image'
        sizes="(max-width: 768px) 100vw, 50vw"
        fill
        className={`object-cover rounded-md`}
        onError={() => setImgError(true)}
        onLoad={() => setLoaded(true)}
      />
    </div> : null
  }


const FeedImages = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState('')
  const imageModalDisclosure = useDisclosure()

  const openImageModal = (imgPath) => {
    setSelectedImage(`${process.env.CDN}/${imgPath}`)
    imageModalDisclosure.onOpen()
  }

  const cleaned = images?.filter((img) => {
    return Boolean(img.trim())
  })
  if (!cleaned || !cleaned.length) return null

  return <>
    {/* Image Modal for fullscreen view */}
    <ImageModal 
      isOpen={imageModalDisclosure.isOpen} 
      onOpenChange={imageModalDisclosure.onOpenChange} 
      imageUrl={selectedImage} 
    />
    {images?.map((img) => {
      return (
        <FeedImage key={img} img={img} openImageModal={openImageModal} />
      )
    })}
  </>
  
}

export default FeedImages